module.exports = __webpack_public_path__ + "static/media/feature-tile-icon-03.8e086eef.svg";